import type { ReactNode } from 'react';

export const symbol_door_back: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M150-120q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h50v-600q0-24 18-42t42-18h440q24 0 42 18t18 42v600h50q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H150Zm110-60h440v-600H260v600Zm133-269q14.45 0 24.23-9.77Q427-468.55 427-483q0-14.45-9.77-24.23Q407.45-517 393-517q-14.45 0-24.23 9.77Q359-497.45 359-483q0 14.45 9.77 24.23Q378.55-449 393-449ZM260-780v600-600Z"
		/>
	</svg>
);
